// extracted by mini-css-extract-plugin
module.exports = {"roleList":"styles_roleList__Kh0SK","roleListBody":"styles_roleListBody__2VBmS","footer":"styles_footer__3z42M"};